import React, {useEffect, useRef, useState} from 'react';
import {Button, Col, Form, message, Row, Select, Input, Checkbox, Image, Upload, Tooltip} from "antd";
import './index.css'
import { useSelector,useDispatch } from 'react-redux';
import {setAllContextMeta} from "../../../../store/modules/user";
import {
    addNewChat,
    hyperChatUploadImage,
    getAllContextMeta,
    getChatResponderList,
    setContextMeta,
    addNewChatBranch
} from "../../../../api/other";

//设置
const SettingApp =(props)=>{
    //父组件传输
    const {handleOk,handleCloseModel,isAdd,addParam,originalScenario} = props
    var {allContextMeta,leftIndex} = useSelector(state => state.user)
    var {chat_meta} = allContextMeta
    const dispatch = useDispatch()
    const [chatResponderList,setChatResponderList] = useState([])
    var isLoad = true;
    useEffect(()=>{
        if(isLoad){
            isLoad = false
            setTimeout(()=>{isLoad=true},500)
            handleInit()
        }
    },[])
    const selectResponderList = (v)=>{
        let data = []
        v.map(res=>{
            data.push({label:res,value:res})
        })
        return data
    }
    const sys_pro = "";
    const handleResetSysPro = ()=>{
        form.setFieldValue('system_prompt',sys_pro)
    }
    //form组件
    const [form] = Form.useForm();
    const onFinish = (values) => {
        // if(!img){
        //     message.error('请上传头像')
        //     return false
        // }
        if(isAdd){
            if(addParam&&originalScenario){
				 if(addParam.responder_content[0]['state']){
					delete addParam.responder_content[0]['state']
				}
                addNewChatBranch({
                    "context_title": values.context_title,
                    "context_group": "default",
                    "responder": values.responder,
                    "responder_avatar": img || 'default',
                    "memory_rounds": values.memory_rounds,
                    "original_scenario": originalScenario,
                    "user_content":addParam.user_content,
                    "responder_content":addParam.responder_content
                }).then(res=>{
                    if(res?.code === 200){
                        getAllContextMeta().then(res=>{
                            if(res.code === 200){
                                dispatch(setAllContextMeta(res.data))
                            }
                        })
                        setTimeout(()=>{handleOk()},500)
                    }
                })
            }else{
                addNewChat({
                    "context_title": values.context_title,
                    "context_group": "default",
                    "responder": values.responder,
                    "responder_avatar": img || 'default',
                    "system_prompt": values.system_prompt,
                    "memory_rounds": values.memory_rounds
                }).then(res=>{
                    if(res?.code === 200){
                        getAllContextMeta().then(res=>{
                            if(res.code === 200){
                                dispatch(setAllContextMeta(res.data))
                            }
                        })
                        setTimeout(()=>{handleOk()},500)
                    }
                })
            }
        }else{
            let v = chat_meta[parseInt(leftIndex)]
            setContextMeta({
                "scenario": "chat",
                "context_id": v.context_id,
                "context_title": values.context_title,
                "context_group": "",
                "responder": values.responder,
                "responder_avatar": img || 'default',
                "system_prompt": values.system_prompt,
                "memory_rounds": values.memory_rounds
            }).then(res=>{
                if(res?.code === 200){
                    message.success('更新成功')
                    getAllContextMeta().then(res=>{
                        if(res.code === 200){
                            dispatch(setAllContextMeta(res.data))
                        }
                    })
                    setTimeout(()=>{handleOk()},500)
                }
            })
        }

    };
    const handleInit = async()=>{
        let data = {}
        if(!isAdd){
            if(chat_meta[parseInt(leftIndex)]){
                let v = chat_meta[parseInt(leftIndex)]
                data = {
                    context_title:v.context_title,
                    memory_rounds:v.memory_rounds,
                    responder:v.responder,
                    system_prompt:v.system_prompt
                }
                setChatResponderList(selectResponderList(v['responder_list']))
                setImg(v['responder_avatar'])
            }
        }else{
			data = {
				context_title:"",
				memory_rounds:3,
				responder:null,
				system_prompt:""
			}
			if(!originalScenario){
				data['context_title'] = '未命名语境'
			}else if(originalScenario==='dictionary'){
				data['context_title'] = '继续讨论查词结果'
			}else if(originalScenario==='translating'){
				data['context_title'] = '继续讨论翻译结果'
			}else if(originalScenario==='correcting'){
				data['context_title'] = '继续讨论纠错结果'
			}else if(originalScenario==='analysis'){
				data['context_title'] = '继续讨论分析结果'
			}
            await getChatResponderList().then(res=>{
				data['responder'] = res.data[0]||null
				handleChangeModel(res?.data[0]||null)
                setChatResponderList(selectResponderList(res.data))
            })
            // setImg('https://light-word.cn/s3/llm-context-files/9e61a0b43a7549299514de8c4f59afe7/d87853505c6d4d2d9ce425a1b0fc575e.png')
        }
        form.setFieldsValue(data)
    }
    const handleChangeModel = (e)=>{
        if(!img || img.includes('common-images')){
            let defaultUrl = 'https://light-word.cn/s3/common-images/'
            if(e==='gpt-4o-mini-free-trial') defaultUrl+="OpenAI.png"
            else if(e==='gpt-4o-mini') defaultUrl+="OpenAI.png"
            else if(e==='gpt-4o') defaultUrl+="OpenAI.png"
            // else if(e==='gpt-4o-2024-08-06') defaultUrl+="OpenAI.png"
            // else if(e==='gpt-4-turbo') defaultUrl+="OpenAI.png"
            // else if(e==='gpt-4') defaultUrl+="OpenAI.png"
            // else if(e==='gpt-3.5-turbo') defaultUrl+="OpenAI.png"
            else if(e==='o1-preview') defaultUrl+="OpenAI.png"
            else if(e==='o1-mini') defaultUrl+="OpenAI.png"
            else if(e==='claude-3-5-sonnet-20241022') defaultUrl+="Anthropic.jpeg"
            else if(e==='claude-3-5-haiku-20241022') defaultUrl+="Anthropic.jpeg"
            else if(e==='claude-3-opus-20240229') defaultUrl+="Anthropic.jpeg"
            else if(e==='gemini-1.5-pro-002') defaultUrl+="google.png"
            else if(e==='gemini-1.5-flash-002') defaultUrl+="google.png"
            else if(e==='llama-3.1-405b-instruct') defaultUrl+="meta.png"
            else if(e==='llama-3.1-70b-instruct-turbo') defaultUrl+="meta.png"
            else if(e==='llama-3.1-8b-instruct') defaultUrl+="meta.png"
            else if(e==='grok-beta') defaultUrl+="xAI.png"
            setImg(defaultUrl)
        }

    }
    const [img,setImg] = useState('')
    //校验失败
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    //更新头像
    const propsUpload = {
        accept:'image/*',
        beforeUpload: async(file) => {
            await hyperChatUploadImage({file}).then(res=>{
                if(res.code === 200){
                    setImg(res?.data.img_url)
                }
            })
            return Upload.LIST_IGNORE;
        }
    };
    return (
        <div className="SettingApp">
            <Form onFinish={onFinish} form={form} onFinishFailed={onFinishFailed}>
                <Row gutter={16}>
                    <Col className="gutter-row" span={18}>
                        <div className='fL'>语境名称</div>
                        <div>
                            <Form.Item label="" name="context_title" rules={[ { required: true, message: '请输入名称', } ]} >

                                <Input placeholder={'请输入名称'} />
                            </Form.Item>
                        </div>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <div className='fL textCenter'>个性头像</div>
                        <div>
                            <Upload {...propsUpload}>
                                <Tooltip placement="bottom" title={'修改'}>
                                	<Image className={'hover'} src={img} width={50} height={50} style={{borderRadius:'50px'}} preview={false}></Image>
                                </Tooltip>
                            </Upload>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col className="gutter-row" span={18}>
                        <div className='fL'>对话模型</div>
                        <div>
                            <Form.Item label="" name="responder" rules={[ { required: true, message: '请选择对话模型', } ]}>
                                <Select placeholder={'请选择对话模型'} onChange={handleChangeModel}
                                        style={{
                                            width: '100%',
                                        }}
                                        options={chatResponderList}
                                />
                            </Form.Item>
                        </div>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <div className='fL textCenter'>记忆窗口</div>
                        <div>
                            <Form.Item label="" name="memory_rounds" rules={[ { required: true, message: '请输入记忆窗口', } ]}>
                                <Input type={'number'} placeholder={'请输入'}  />
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16}>
                    {
                        originalScenario?
                            <Col className="gutter-row" span={24}>
                                <div className='fL'>
                                    系统提示
                                    <Image className={'flImgReset'} src={require('../../../../assets/comm/ai-chat-t-reset.png')} width={16} preview={false} ></Image>
                                </div>
                                <div>
                                    <Form.Item name="system_prompt">
                                        <Input.TextArea placeholder={'自动生成'} disabled={true} rows={10} />
                                    </Form.Item>
                                </div>
                            </Col>:
                            <Col className="gutter-row" span={24}>
                                <div className='fL'>
                                    系统提示
                                    <Image onClick={handleResetSysPro} className={'flImgReset'} src={require('../../../../assets/comm/ai-chat-t-reset.png')} width={16} preview={false} ></Image>
                                </div>
                                <div>
                                    <Form.Item name="system_prompt">
                                        <Input.TextArea placeholder={'可以在此设置您需要的对话情景，例如让大模型扮演一个赛博猫娘...'} rows={10} />
                                    </Form.Item>
                                </div>
                            </Col>
                    }

                </Row>
                <Form.Item>
                    <div className='textRight'>
                        <Button className='selfBtn' htmlType="submit">
                            确定
                        </Button>
                        <Button className='selfBtn btn2' onClick={handleCloseModel}>
                            取消
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </div>
    )
}

export default SettingApp
